import * as React from "react";
import { GlobalContext } from "../../context/GlobalContextProvider";
import { useEffectOnce } from "../../helpers/useEffectOnce";

interface IProps {}

export const HotkeySwitch: React.FC<IProps> = (props) => {
    const globalContext = React.useContext(GlobalContext);

    const isSuperUser = globalContext.user?.isSuperuser || false;

    const onKeyDown = (event: KeyboardEvent) => {
        if (
            (event.key === " " && event.ctrlKey) ||
            (event.key === "k" && event.ctrlKey)
        ) {
            globalContext.tenantSwitchModal.onChange(true);
            event.preventDefault();
        }
    };

    useEffectOnce(() => {
        if (!isSuperUser) {
            return;
        }

        window.addEventListener("keydown", onKeyDown);

        return () => {
            window.removeEventListener("keydown", onKeyDown);
        };
    });

    return null;
};
